/**
 * Generate a unique ID similar to UUID v4
 * This is a simplified implementation that generates a random ID
 * Not cryptographically secure, but sufficient for development purposes
 */
export const generateId = (): string => {
  // Generate random hexadecimal segments
  const s4 = () => 
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  
  // Format similar to UUID to maintain compatibility
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}; 